import { Outlet } from 'react-router-dom'

const Voucher = () => <Outlet />

export default Voucher
